/* @flow */

import all from 'src/shared/app/base/style/element/base/all';
import root from 'src/shared/app/base/style/element/base/root';
import selection from 'src/shared/app/base/style/element/base/selection';
import box from 'src/shared/app/base/style/element/form/box';
import button from 'src/shared/app/base/style/element/form/button';
import dropdown from 'src/shared/app/base/style/element/form/dropdown';
import fieldset from 'src/shared/app/base/style/element/form/fieldset';
import label from 'src/shared/app/base/style/element/form/label';
import textControl from 'src/shared/app/base/style/element/form/textControl';
import media from 'src/shared/app/base/style/element/media/media';
import body from 'src/shared/app/base/style/element/sectioning/body';
import description from 'src/shared/app/base/style/element/text-content/description';
import heading from 'src/shared/app/base/style/element/text-content/heading';
import list from 'src/shared/app/base/style/element/text-content/list';
import paragraph from 'src/shared/app/base/style/element/text-content/paragraph';
import strong from 'src/shared/app/base/style/element/text-semantics/strong';
import link from 'src/shared/app/base/style/element/text-semantics/link';
import small from 'src/shared/app/base/style/element/text-semantics/small';
import mui from 'src/shared/app/base/style/override/mui';

export default {
  '@global': {
    // Base
    ...root,
    ...selection,
    ...all,
    // Form
    ...box,
    ...button,
    ...dropdown,
    ...fieldset,
    ...label,
    ...textControl,
    // Media
    ...media,
    // Sectioning
    ...body,
    // Text content
    ...description,
    ...heading,
    ...list,
    ...paragraph,
    // Text semantics
    ...link,
    ...small,
    ...strong,
    // Override
    ...mui,
  },
};
